import * as Actions from "../../actions/actions";

const initialState = {
  singleQuestion: {},
  selectedAnswer: null,
  questionId: null,
  userQuizAnswer: null,
  reviewStepsSubmitted: [],
  reviewResponse: {},
  isReviewNew: false,
};

const course = (state = initialState, action) => {
  switch (action.type) {
    case Actions.RESET_REVIEW_REDUCER:
      return initialState;
    case Actions.GET_SINGLE_QUESTION:
      return {
        ...state,
        singleQuestion: action.data,
      };
    case Actions.REVIEW_SELECTED_ANSWER:
      return {
        ...state,
        selectedAnswer: action.data,
      };
    case Actions.QUESTION_ID_REVIEW:
      return {
        ...state,
        questionId: action.data,
      };
    case Actions.USER_QUIZ_ANSWER_SUBMITTED:
      return {
        ...state,
        userQuizAnswer: action.data,
      };
    case Actions.SAVE_REVIEW_STEP:
      return {
        ...state,
        reviewStepsSubmitted: action.data,
      };
    case Actions.SAVE_USER_QUIZ_ID_FOR_REVIEW:
      return {
        ...state,
        userQuizId: action.data,
      };
    case Actions.SAVE_REVIEW_RESPONSE:
      return {
        ...state,
        reviewResponse: action.data,
      };
    case Actions.SAVE_IS_REVIEW_NEW:
      return {
        ...state,
        isReviewNew: action.data,
      };
    case Actions.SAVE_REVIEW_TAGS:
      return {
        ...state,
        tags: action.data,
      };
    case Actions.SAVE_REVIEW_TAGS_RESPONSE:
      return {
        ...state,
        tagsResponse: action.data,
      };
    case Actions.SAVE_REVIEW_FEEDBACK_STATUS:
      return {
        ...state,
        feedbackStatus: action.data,
      };

    default:
      return state;
  }
};
export default course;
